import React,{useState} from 'react'
import './DetailsFeatures.css';
import {Grid,FormControlLabel,Checkbox} from '@mui/material';

const DetailsFeatures = () => {

    var arr=['Bathroom','Stereo','Stereo Aux Input','Bluetooth Audio','Floating Mat','Floating Island','Cooler/Ice Chest','Air conditioning','Swim Ladder',"Children's Life Jackets",'Shower','Wifi','Deck Shower','Refrigerator','Anchor','Fish Finder','Grill','Bow Thruster','GPS','Depth Finder','Radar','VHF Radio']
    const [windowWidth, setWindowWidth] = useState(window.outerWidth);

    window.addEventListener('resize',function (){
      setWindowWidth(window.outerWidth)
    })
  
    return (
    <div className='DetailsFeaturesMain'>
        <p style={{fontWeight:700,fontSize:22,textAlign:'left',marginTop:30}}>Features</p>
        <Grid container>
            <Grid item  md={windowWidth>1070 ? 8 : 9} lg={7} xl={5.5}>
        <div className='detailsFeatureDiv'>
            <Grid container style={{paddingLeft:'10px'}}>
            {
                arr.map(v=>(
                    <Grid item md={4} sm={6} xs={windowWidth>495 ? 6 : 'auto'} style={{justifyContent:'flex-start',alignItems:'flex-start',display:'flex'}}>
                        <FormControlLabel control={<Checkbox />} label={v} />
                    </Grid>
                ))
            }
            </Grid>
        </div>
            </Grid>
        </Grid>
    </div>
  )

}

export default DetailsFeatures